import { Formatting } from '../../data/formatting';
import { DataStore } from '../../data/store';
import { TrendRow, TrendValue, TrendsInfo } from '../../design/charts';

export function makeTrendInfo(
  data: DataStore,
  options: {
    grouping: string;
    kpi: string;
    secondaryKpi?: string;
    includeTotals: boolean;
    totalName?: string;
    title?: string;
  }
): { info: TrendsInfo; title?: string } | undefined {
  const { grouping, kpi, secondaryKpi, includeTotals, totalName, title } = options;

  const currency = data.getCurrency();
  const column = data.getDataColumn(kpi);
  const secondaryColumn = secondaryKpi ? data.getDataColumn(secondaryKpi) : undefined;

  const dataSrc = data.getGroupedData([grouping])[0];
  if (!column || !dataSrc) {
    return;
  }

  const rows: TrendRow[] = [];

  if (includeTotals) {
    const totalsData = data.getGroupedData([])[0];
    if (totalsData) {
      const values = totalsData.data[0]?.values[column.name] as (number | null)[];
      const valuesList: TrendValue[] = values
        ? values.map(value => ({
            raw: value,
            formatted: Formatting.format(value, {
              dataType: column.dataType,
              formatHint: column.formatHint,
              currency,
            }),
          }))
        : Array(column.arrayLength)
            .fill(null)
            .map(_ => ({
              raw: null,
              formatted: '-',
            }));

      rows.push({
        label: totalName || 'Market',
        isTotals: true,
        values: valuesList,
      });
    }
  }

  dataSrc.data.forEach(dataRow => {
    const { name } = DataStore.getRowIdentifiers(dataRow, data.getDataColumns(), grouping);
    const values = dataRow.values[column.name] as (number | null)[];
    const secondaryValues = secondaryColumn ? (dataRow.values[secondaryColumn.name] as (number | null)[]) : undefined;
    const currency = data.getCurrency();

    const valuesList: TrendValue[] = values
      ? values.map((value, idx) => ({
          raw: value,
          formatted: Formatting.format(value, {
            dataType: column.dataType,
            formatHint: column.formatHint,
            currency,
          }),
          secondaryFormatted: secondaryValues
            ? Formatting.format(secondaryValues[idx], {
                dataType: secondaryColumn.dataType,
                formatHint: secondaryColumn.formatHint,
                currency,
              })
            : undefined,
        }))
      : Array(column.arrayLength)
          .fill(null)
          .map(_ => ({
            raw: null,
            formatted: '-',
          }));

    rows.push({
      label: name,
      values: valuesList,
    });
  });

  return {
    info: {
      rows,
      periods: dataSrc.timeFrame.periods.map(p => p.name),
    },
    title,
  };
}
